export default __webpack_public_path__ + "static/desktop-d097256932ea08c36fd19cda0c4b1ff3.jpg";